import { createEl } from "./domUtils";
export default class Utils {
  constructor() {
    this.color = 0x4444aa;
  }

  static get DEFAULT_COLOR() {
    return 0x4444aa;
  }

  static save(content, fileName, contentType) {
    var a = document.createElement("a");
    var file = new Blob([content], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }
  static map(x, inMin, inMax, outMin, outMax) {
    return ((x - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  }

  static loadJSON(json_url) {
    return fetch(json_url)
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {
        console.log("error", error);
      });
  }

  static postJSON(json_url, data) {
    return fetch(json_url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => json);
  }

  static checkIfImageExists(image_url) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.onload = () => {
        if (img.height != 0) resolve(true);
        else resolve(false);
      };
      img.onerror = () => {
        resolve(false);
      };
      img.src = image_url;
    });
  }

  static createArrayOfNumbers(max = 1) {
    let array = [];
    for (let i = 0; i < max; i++) {
      array.push(i);
    }
    return array;
  }

  static suffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  static replaceAt(str, index, char) {
    let a = str.split("");
    a[index] = char;
    return a.join("");
  }

  static putValueAtFirstPosition(array, value) {
    let index = array.indexOf(value);
    console.log("flip the index", index, value);
    if (index > -1) {
      array.splice(index, 1);
    }
    array.unshift(value);
    return array;
  }

  static transformMessageIntoTypewriterData(message) {
    let data = { timings: [], letters: [], actions: [] };
    for (let i = 0; i < message.length; i++) {
      data.timings.push(150 + Math.floor(Math.random() * 300));
      data.letters.push(message[i]);
      data.actions.push("+");
    }
    // add 3 white spaces at the end
    for (let i = 0; i < 3; i++) {
      data.timings.push(300);
      data.letters.push(" ");
      data.actions.push("+");
    }
    return data;
  }

  static translate(message, dict) {
    // console.log(message);
    // console.log(dict);
    // console.log(dict[message]);
    return dict[message];
  }

  static convertKeyWordIntoTag(string, keyword, tag) {
    const regex = new RegExp(keyword, "g");
    const parts = string.split(regex);
    const _children = [];
    parts.forEach((part, index) => {
      if (index < parts.length - 1)
        _children.push(part, { el: tag, text: keyword });
      else _children.push(part);
    });
    return createEl({
      el: null,
      children: _children,
    });
  }
}
